module.exports = __webpack_public_path__ + "img/custodian-community-logo.5920191d.png";